import React, { useEffect, useState } from 'react';
import './pagemenu.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { logNavigation } from '../utils/diagnosticLogger';
import { useUserContext } from './UserContext';
import { fetchCrmSummary } from './api';

// The menu is drawn twice (header and mobile bottom bar), so the inbox count is shared
// and refreshed at most once a minute.
let inboxCount = { value: null, at: 0, pending: null };
const loadInboxCount = () => {
  if (Date.now() - inboxCount.at < 60000) return Promise.resolve(inboxCount.value);
  if (!inboxCount.pending) {
    inboxCount.pending = fetchCrmSummary()
      .then((s) => { inboxCount = { value: s.new, at: Date.now(), pending: null }; return s.new; })
      .catch(() => { inboxCount = { ...inboxCount, pending: null }; return null; });
  }
  return inboxCount.pending;
};

const PageMenu = ({ className, onNavigate }) => {
    let navigate = useNavigate();
    const location = useLocation();
    const { user } = useUserContext();
    const isSales = Boolean(user && user.is_sales);
    const [newInquiries, setNewInquiries] = useState(null);

    useEffect(() => {
      if (!isSales) return undefined;
      let active = true;
      loadInboxCount().then((n) => { if (active) setNewInquiries(n); });
      return () => { active = false; };
    }, [isSales, location.pathname]);

    function goToRetail() {
        logNavigation(location.pathname, '/', 'menu-click-retail');
        navigate('/');
        if (onNavigate) onNavigate();
      }
    
      function goToJobs() {
        logNavigation(location.pathname, '/jobs', 'menu-click-jobs');
        navigate('/jobs');
        if (onNavigate) onNavigate();
      }

      function goToInbox() {
        logNavigation(location.pathname, '/inbox', 'menu-click-inbox');
        navigate('/inbox');
        if (onNavigate) onNavigate();
      }

      function goToAccounts() {
        logNavigation(location.pathname, '/accounts', 'menu-click-accounts');
        navigate('/accounts');
        if (onNavigate) onNavigate();
      }

  return (
    <div className={`pagemenu ${className || ''}`} >

        <button
          className={`headerbutton ${location.pathname === '/' ? 'active' : ''}`}
          onClick={goToRetail}
        >
          Retail
        </button>

        <button
          className={`headerbutton ${location.pathname === '/jobs' ? 'active' : ''}`}
          onClick={goToJobs}
        >
          Jobs
        </button>

        {isSales && (
          <button
            className={`headerbutton pagemenu-inbox ${location.pathname === '/inbox' ? 'active' : ''}`}
            onClick={goToInbox}
          >
            Inbox
            {newInquiries > 0 && <span className="pagemenu-inbox-badge">{newInquiries}</span>}
          </button>
        )}

        <button
          className={`headerbutton ${location.pathname === '/accounts' ? 'active' : ''}`}
          onClick={goToAccounts}
        >
          Accounts
        </button>
    </div>
  );
};

export default PageMenu;